import {Injectable, inject} from '@angular/core'
import type {MonitoringTrace} from '@models/monitoring/monitoring-trace'
import {ApiService} from '@service/api.service'
import type {MonitoringSink} from './monitoring-sink'

@Injectable({providedIn: 'root'})
export class QueueMonitoringSink implements MonitoringSink {
  private readonly api = inject(ApiService)

  enqueue(trace: MonitoringTrace): Promise<void> {
    return this.api.enqueueMonitoringTrace(trace)
  }
}
